import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { useNavigate, useParams } from 'react-router-dom';
import Heading from '../../../components/Typography/Heading/Heading';
import CancelIcon from '../../../components/CancelIcon/CancelIcon';
import Paragraph from '../../../components/Typography/Paragraph/Paragraph';
import styles from './ResultView.module.scss';
import { AboutTrack } from '../../../components/AboutTrack/AboutTrack';
import { raceResultById } from '../../../store/selectors/resultsSelectors';
import PlaceCard from './PlaceCard/PlaceCard';
import Tooltip from '../../../components/Tooltip/Tooltip';
import DropdownMenuElemToggle from '../../../components/DropDownMenu/DropdownMenuElemToggle/DropdownMenuElemToggle';
import ChartHeader from './WinningChart/ChartHeader/ChartHeader';
import ChartRow from './WinningChart/ChartRow/ChartRow';
import ChartRowAlt from './WinningChart/ChartRow/ChartRowAlt';
import ChartHeaderAlt from './WinningChart/ChartHeader/ChartHeaderAlt';
const chart = [
    {
        id: 1,
        time: '1m 22.53s',
        gate: 2,
        horse: 'Five Rings',
        jockey: 'Malik (Wise)',
        class: 3,
        place: 1,
        stable: "Thor's Breeding",
        guild: 'Mamba Forever'
    },
    {
        id: 2,
        time: '1m 22.53s',
        gate: 2,
        horse: 'Five Rings',
        jockey: 'Malik (Wise)',
        class: 3,
        place: 2,
        stable: "Thor's Breeding",
        guild: 'Mamba Forever'
    },
    {
        id: 3,
        time: '1m 22.53s',
        gate: 2,
        horse: 'Five Rings',
        jockey: 'Malik (Wise)',
        class: 3,
        place: 3,
        stable: "Thor's Breeding",
        guild: 'Mamba Forever'
    },
    {
        id: 4,
        time: '1m 22.53s',
        gate: 2,
        horse: 'Five Rings',
        jockey: 'Malik (Wise)',
        class: 3,
        place: 4,
        stable: "Thor's Breeding",
        guild: 'Mamba Forever'
    }
];
const podium = [1, 2, 3];
const ResultView = ({ className, onClose }) => {
    var _a, _b;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();
    const race = useSelector((state) => raceResultById(state, params.id));
    const [altStats, setAltStats] = useState(false);
    const darkMode = useSelector((state) => state.settings.darkMode);
    const condition = {
        [t('weather')]: ((_a = race === null || race === void 0 ? void 0 : race.weather) === null || _a === void 0 ? void 0 : _a.description) || '',
        [t('track_surface')]: (race === null || race === void 0 ? void 0 : race.trackDetails.surface) || '',
        [t('wind')]: ((_b = race === null || race === void 0 ? void 0 : race.weather) === null || _b === void 0 ? void 0 : _b.wind) || '',
        [t('track_ratings')]: (race === null || race === void 0 ? void 0 : race.trackDetails.rating) || ''
    };
    const renderList = () => {
        return chart.map((it) => {
            if (altStats) {
                return (_jsx(ChartRowAlt, { winner: it, isPodium: podium.includes(it.place), isMine: it.place === 4, isDarkMode: darkMode }, it.id));
            }
            return (_jsx(ChartRow, { winner: it, isPodium: podium.includes(it.place), isMine: it.place === 4, isDarkMode: darkMode }, it.id));
        });
    };
    return (_jsxs("div", Object.assign({ className: cn(styles.element, className) }, { children: [_jsxs("div", Object.assign({ className: 'd-flex align-items-center justify-content-between' }, { children: [_jsx("div", Object.assign({ className: 'd-flex align-items-center' }, { children: _jsx(Heading, { size: 1, title: t('prize_split'), fontWeight: 400 }) })), _jsx("div", Object.assign({ className: 'd-flex align-items-center' }, { children: _jsx(CancelIcon, { className: cn(styles.cancel), onClick: onClose }) }))] })), _jsxs("div", Object.assign({ className: styles.prizePool }, { children: [_jsxs("div", Object.assign({ className: 'd-flex align-items-center' }, { children: [_jsx(Paragraph, { title: 'Total prize pool of', size: 2, fontFamily: 'marope', color: 'black' }), _jsx(Paragraph, { title: '380 Coins', color: 'black', size: 2, fontFamily: 'marope', className: styles.coins }), _jsx(Paragraph, { title: 'was splited as follows:', size: 2, fontFamily: 'marope', color: 'black' })] })), _jsxs("div", Object.assign({ className: cn(styles.placesBox, 'd-flex justify-content-between') }, { children: [_jsx(PlaceCard, { horseName: 'Boom Tune', title: '1st place', prize: 240 }), _jsx(PlaceCard, { horseName: 'Soaring Sultan', title: '2nd place', prize: 90 }), _jsx(PlaceCard, { horseName: 'Power Full', title: '3rd place', prize: 30 })] })), _jsxs("div", Object.assign({ className: styles.conditions }, { children: [_jsx(Heading, { size: 1, title: t('conditions'), fontWeight: 400 }), _jsx(AboutTrack, { elem: condition, borderRight: true, className: styles.table })] })), _jsxs("div", Object.assign({ className: styles.winningChart }, { children: [_jsxs("div", Object.assign({ className: 'd-flex align-items-center' }, { children: [_jsx(Heading, { size: 1, title: t('winning_chart'), fontWeight: 400 }), _jsx(Tooltip, Object.assign({ content: "Show alternate stats" }, { children: _jsx(DropdownMenuElemToggle, { className: cn(styles.toggle), checked: altStats, onClick: () => setAltStats(!altStats) }) }))] })), _jsxs("div", Object.assign({ className: styles.chart }, { children: [altStats ? _jsx(ChartHeaderAlt, {}) : _jsx(ChartHeader, {}), renderList()] }))] }))] }))] })));
};
export default ResultView;
